<template>
  <v-container fluid class="px-6 py-12">
    <br>
     <br>
     <br>
    <!-- Título -->
    <h1 class="text-center font-weight-bold mb-2 poppinsFont">Componentes de Botón</h1>
    <p class="text-center mb-12">Jerarquía completa de botones interactivos</p>

    <!-- Anatomía y Estados -->
     
    <v-row>
      <v-col cols="12" md="8">
        <v-card class="pa-6" elevation="2" rounded>
          <h3 class="font-weight-bold mb-6">Anatomía del Botón</h3>

          <!-- Botón visual -->
          <div
            class="d-inline-flex align-center justify-center"
            style="background: linear-gradient(to right, #6366F1, #8B5CF6); padding: 12px 32px; border-radius: 12px; color: white; font-family: 'Axiforma', sans-serif; font-weight: 600; font-size: 16px;"
          >
            <v-icon left>mdi-plus</v-icon> Crear Proyecto
          </div>

          <!-- Elementos -->
          <ul class="mt-6" style="font-size: 14px;">
            <li>• Icono (opcional) – 20px</li>
            <li>• Texto – Axiforma SemiBold 16px</li>
            <li>• Container – 12px border-radius</li>
            <li>• Padding – 12px vertical, 32px horizontal</li>
          </ul>
        </v-card>
      </v-col>

      <!-- Estados -->
      <v-col cols="12" md="4">
        <v-card class="pa-6" elevation="2" rounded>
          <h3 class="font-weight-bold mb-4">Estados Interactivos</h3>
          <v-btn block style="background: linear-gradient(to right, #6366F1, #8B5CF6);">Default</v-btn>
          <v-btn block class="mt-2" style="background: linear-gradient(to right, #7C5CF6, #7F46E3);">Hover</v-btn>
          <v-btn block class="mt-2" style="background: linear-gradient(to right, #5B2ED4, #6B21A8);">Active</v-btn>
          <v-btn block class="mt-2" disabled color="#F3F4F6">Disabled</v-btn>
        </v-card>
      </v-col>
    </v-row>

    <!-- Secciones de botones -->
    <v-row class="mt-12" dense>
      <!-- Grupo: Principales -->
      <v-col cols="12" md="3">
        <v-card class="pa-4" elevation="2" rounded>
          <h3 class="font-weight-bold mb-4">Principales</h3>
          <v-btn block class="mb-2" style="background: linear-gradient(to right, #6366F1, #8B5CF6); color: white;">
            <v-icon left>mdi-plus</v-icon> Principal
          </v-btn>
          <v-btn block style="background-color: #FFD60A; color: #000;">
            <v-icon left>mdi-star-outline</v-icon> Destacado
          </v-btn>
        </v-card>
      </v-col>

      <!-- Grupo: Energía -->
      <v-col cols="12" md="3">
        <v-card class="pa-4" elevation="2" rounded>
          <h3 class="font-weight-bold mb-4">Energía</h3>
          <v-btn block class="mb-2" style="background-color: #84CC16; color: #000;">
            <v-icon left>mdi-white-balance-sunny</v-icon> Renovable
          </v-btn>
          <v-btn block style="background-color: #F59E0B; color: #000;">
            <v-icon left>mdi-flash-outline</v-icon> Eficiencia
          </v-btn>
        </v-card>
      </v-col>

      <!-- Grupo: Ambiente -->
      <v-col cols="12" md="3">
        <v-card class="pa-4" elevation="2" rounded>
          <h3 class="font-weight-bold mb-4">Ambiente</h3>
          <v-btn block class="mb-2" style="background-color: #06B6D4; color: #fff;">
            <v-icon left>mdi-waves</v-icon> Recursos
          </v-btn>
          <v-btn block style="background-color: #06B6D4; color: #fff;">
            <v-icon left>mdi-recycle</v-icon> Circular
          </v-btn>
        </v-card>
      </v-col>

      <!-- Grupo: Sostenibilidad -->
      <v-col cols="12" md="3">
        <v-card class="pa-4" elevation="2" rounded>
          <h3 class="font-weight-bold mb-4">Sostenibilidad</h3>
          <v-btn block class="mb-2" style="background-color: #10B981; color: #fff;">
            <v-icon left>mdi-leaf</v-icon> Verde
          </v-btn>
          <v-btn block style="background: linear-gradient(to right, #10B981, #84CC16); color: #fff;">
            <v-icon left>mdi-check-circle-outline</v-icon> Logrado
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ButtonsView'
}
</script>

<style scoped>
.poppinsFont {
  font-family: 'Poppins', sans-serif;
}
</style>
